<template>
    <div class="input-group">
        <span class="input-group-addon flag" :title="translation"><img :src="'/img/flag/' + $i18n.locale() + '.png'" /></span>
        <input v-if="!textarea" type="text" v-model="val" v-on:input="$emit('input', val)" class="form-control" />
        <textarea v-if="textarea" v-model="val" v-on:input="$emit('input', val)" class="form-control" />
    </div>
</template>

<script>
    export default {
        name: 'tinput',
        props: {
            textarea: {default: false},
            value: {default: ""},
        },
        computed: {
            translation() {
                if(this.$i18n.locale() == 'en')
                {
                    return "English Translation";
                }
                else
                {
                    return "Spanish Translation";
                }
            }
        },
        watch: {
            value(newVal) {
                this.val = newVal;
            }
        },
        data() {
            return {
                val: ""
            };
        },
        mounted() {
            this.val = this.value;
        }
    }
</script>

<style>
    .input-group-addon.flag > img {
        margin-top: -2px;
    }
</style>

